module.exports = __webpack_public_path__ + "img/calendar.8f95ad79.svg";